import axios from 'axios';
import { RelazioneMedica, IdVersion, RelazioneMedicaCreateCommand, RelazioneMedicaUpdateCommand } from '../types';
import { utilityService } from './common/utility-service';

const baseUrl = '/api/v1/relazioni-mediche';

export const getByKey = async (id: number): Promise<RelazioneMedica> => {
    return (await axios.get(`${baseUrl}/${id}`)).data;
};
export const getByPrestazione = async (id: number): Promise<RelazioneMedica> => {
    return (await axios.get(`${baseUrl}/prestazione/${id}`)).data;
};

export const create = async (command: RelazioneMedicaCreateCommand): Promise<IdVersion> => {
    return (await axios.post(`${baseUrl}/create`, command)).data;
};

export const update = async (command: RelazioneMedicaUpdateCommand): Promise<IdVersion> => {
    return (await axios.post(`${baseUrl}/update`, command)).data;
};

export const remove = async (items: IdVersion[]): Promise<void> => {
    return (await axios.delete(`${baseUrl}/remove?${utilityService.toQueryStringMultiple(items)}`)).data;
};